// A round glass button floating over a viewer (close, "…"). The glass is
// `media-floating` in media.css, made from the theme's surface color, so both
// themes follow without overrides.
import type { ReactNode, Ref } from "react";

/**
 * 48 high like the iOS Safari bottom bar buttons, which sit right below on a
 * phone: matching them reads as one row. One pixel wider (49) than high, which
 * looks calmer than a perfect circle (user decision).
 */
const HEIGHT = 48;
const WIDTH = 49;

export function FloatingIconButton({
  ref,
  label,
  expanded,
  hasPopup,
  disabled,
  onClick,
  children,
}: {
  ref?: Ref<HTMLButtonElement>;
  label: string;
  expanded?: boolean;
  hasPopup?: "menu" | "dialog";
  /** Shown faint and not pressed (zooming past its end). */
  disabled?: boolean;
  onClick(): void;
  children: ReactNode;
}) {
  return (
    <button
      ref={ref}
      type="button"
      aria-label={label}
      aria-expanded={expanded}
      aria-haspopup={hasPopup}
      disabled={disabled}
      // Pressing does not move the focus. iOS Safari does not focus a tapped
      // button; it focuses the nearest focusable ancestor instead and scrolls to
      // show it, which made the page jump. A Tab-reached focus stays as it is.
      onMouseDown={(e) => e.preventDefault()}
      onClick={onClick}
      style={{ width: WIDTH, height: HEIGHT, borderRadius: HEIGHT / 2 }}
      className="media-floating media-floating-icon flex shrink-0 cursor-pointer items-center justify-center text-fg disabled:cursor-default disabled:[&>*]:opacity-35"
    >
      {children}
    </button>
  );
}
